/* unplugin-vue-components disabled */import { render } from "./Detail.vue?vue&type=template&id=0b1a84b5&scoped=true&ts=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=0b1a84b5&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1a84b5"]])

export default __exports__